import { saveAs } from 'file-saver';
import { Subscription as rxjsSubscription } from 'rxjs';
import { Component, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { Subscription } from 'core/models/subscription';
import { ModalComponent } from 'core/components';
import { SubscriptionsService } from 'core/services';
import { StoreService } from 'core/services/store.service';
import { SubscriptionListService } from './client-subscription-list.service';

@Component({
  selector: 'lms-client-subscriptions-list',
  templateUrl: './client-subscriptions-list.component.html',
  styleUrls: ['./client-subscriptions-list.component.scss'],
  providers: [SubscriptionListService]
})
export class ClientSubscriptionsListComponent implements OnInit, OnDestroy {
  @Input() listId = 'CLIENT_SUBSCRIPTIONS_LIST';
  @Input() options: any;
  @Input() client: any;
  @Input() type: string;
  @ViewChild(ModalComponent, { static: false }) public modalComponent: ModalComponent;

  public subscriptions: Subscription[];
  public timezone: string;
  public listOptions: any;

  private downloadSubscriptionReportSubscription: rxjsSubscription = new rxjsSubscription();

  private filters: any;
  private defaultOptions: any = {
    elementsName: 'credits.label',
    sort: '-endDate',
    hidePaginator: true
  };
  public dataSource: any;
  actionsSubscription: rxjsSubscription;

  constructor(
    public subscriptionsService: SubscriptionsService,
    public subscriptionListService: SubscriptionListService
  ) {}

  ngOnInit() {
    this.actionsSubscription = this.subscriptionListService
      .getActionEmitter()
      .subscribe((event) => this.onListAction(event));
    this.timezone = this.client.timezone;
  }

  async ngOnChanges() {
    this.filters = { clientId: this.client.id, type: this.type };
    this.listOptions = Object.assign(
      { filters: this.filters, timezone: this.client.timezone },
      this.defaultOptions,
      this.options
    );
    this.dataSource = await this.subscriptionListService.getDatasource(this.listId, this.listOptions);
  }

  ngOnDestroy(): void {
    this.downloadSubscriptionReportSubscription.unsubscribe();
    this.actionsSubscription.unsubscribe();
  }

  onListAction(event) {
    const { action, subscription } = event;
    if (action === 'download') {
      this.downloadSubscriptionReport(subscription.id);
    }
  }

  onDatasourceUpdate(dataSource) {
    this.dataSource = dataSource;
    StoreService.update(this.listId, this.dataSource);
  }

  public downloadSubscriptionReport(subscriptionId: string) {
    this.downloadSubscriptionReportSubscription = this.subscriptionsService
      .downloadSubscriptionReport(subscriptionId)
      .subscribe((res) => {
        const clientName = this.client.name.split(' ').join('');

        saveAs(res, `SubscriptionReport_${clientName}-${subscriptionId}.csv`);
      });
  }
}
